import React, { useState } from 'react';
import './HrmsHomeScreen.css';
import Logo from '../../assets/images/tthrms.svg';
import EmployeesHome from '../EmployeesHome/EmployeesHome';
import CreateEmployeeIndex from '../CreateEmployeeIndex/CreateEmployeeIndex';
import EmployeeLeaveHome from '../EmployeeLeaveHome/EmployeeLeaveHome';
import CompensationHome from '../CompensationHome/CompensationHome';
import AccountingHome from '../AccountingHome/AccountingHome';
import AdminLeaveHome from '../AdminLeaveHome/AdminLeaveHome';
import CTCCalculator from '../CTCCalculator/CTCCalculator';
import DocumentsHome from '../DocumentsHome/DocumentsHome';

// Icons as SVG components
const DashboardIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <rect x="14" y="14" width="7" height="7" rx="1" />
  </svg>
);

const EmployeesIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <circle cx="9" cy="7" r="4" />
    <path d="M3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2" />
    <circle cx="17" cy="7" r="3" />
    <path d="M21 21v-2a3 3 0 00-3-3h-1" />
  </svg>
);

const CompensationIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" fill="none" />
    <text x="12" y="16" textAnchor="middle" fontSize="10" fill="currentColor">$</text>
  </svg>
);

const TimesheetIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="2" fill="none" />
    <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" strokeWidth="2" />
    <line x1="9" y1="4" x2="9" y2="20" stroke="currentColor" strokeWidth="2" />
  </svg>
);

const LeavesIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M9 3v2H5v14h14v-4h2v4a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h4zm6 0h6v6h-2V6.414l-7 7L10.586 12l7-7H15V3z" />
  </svg>
);

const PayrollIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <rect x="2" y="6" width="20" height="12" rx="2" stroke="currentColor" strokeWidth="2" fill="none" />
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" fill="none" />
    <text x="12" y="14" textAnchor="middle" fontSize="6" fill="currentColor">$</text>
  </svg>
);

const MastersIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="currentColor" strokeWidth="2" fill="none" />
  </svg>
);

const AccountingIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2" fill="none" />
    <line x1="3" y1="9" x2="21" y2="9" stroke="currentColor" strokeWidth="2" />
    <line x1="9" y1="9" x2="9" y2="21" stroke="currentColor" strokeWidth="2" />
  </svg>
);

const SettingsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" fill="none" />
    <path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83" stroke="currentColor" strokeWidth="2" />
  </svg>
);

const DocumentsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" strokeWidth="2" fill="none" />
    <polyline points="14 2 14 8 20 8" stroke="currentColor" strokeWidth="2" fill="none" />
    <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" strokeWidth="2" />
    <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" strokeWidth="2" />
  </svg>
);

const SearchIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <path d="M21 21l-4.35-4.35" />
  </svg>
);

const BellIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0" />
  </svg>
);

// Dashboard Card Icons
const ApprovalsCardIcon = () => (
  <svg width="32" height="32" viewBox="0 0 48 48">
    <circle cx="24" cy="24" r="20" fill="#4CAF50" />
    <path d="M20 28l-4-4 1.5-1.5L20 25l8.5-8.5L30 18z" fill="white" />
  </svg>
);

const LeavesCardIcon = () => (
  <svg width="32" height="32" viewBox="0 0 48 48">
    <circle cx="24" cy="24" r="20" fill="#F44336" />
    <path d="M18 24h8M26 24l-3-3M26 24l-3 3" stroke="white" strokeWidth="2.5" fill="none" />
  </svg>
);

const EmployeesCardIcon = () => (
  <svg width="32" height="32" viewBox="0 0 48 48">
    <circle cx="16" cy="16" r="5" fill="#2196F3" />
    <path d="M8 32c0-4.4 3.6-8 8-8s8 3.6 8 8" fill="#2196F3" />
    <circle cx="32" cy="16" r="5" fill="#64B5F6" />
    <path d="M24 32c0-4.4 3.6-8 8-8s8 3.6 8 8" fill="#64B5F6" />
    <rect x="20" y="10" width="8" height="4" fill="#FFD54F" />
  </svg>
);

const TimesheetCardIcon = () => (
  <svg width="32" height="32" viewBox="0 0 48 48">
    <rect x="8" y="8" width="32" height="32" rx="3" fill="#FF9800" />
    <rect x="12" y="14" width="6" height="6" rx="1" fill="white" />
    <rect x="21" y="14" width="6" height="6" rx="1" fill="white" />
    <rect x="30" y="14" width="6" height="6" rx="1" fill="white" />
    <rect x="12" y="23" width="6" height="6" rx="1" fill="white" />
    <rect x="21" y="23" width="6" height="6" rx="1" fill="white" />
    <rect x="30" y="23" width="6" height="6" rx="1" fill="white" />
    <rect x="12" y="32" width="6" height="6" rx="1" fill="white" />
    <rect x="21" y="32" width="6" height="6" rx="1" fill="white" />
  </svg>
);

const PayrollCardIcon = () => (
  <svg width="32" height="32" viewBox="0 0 48 48">
    <rect x="6" y="12" width="36" height="24" rx="3" fill="#FF5722" />
    <circle cx="24" cy="24" r="6" fill="#FFCC80" />
    <text x="24" y="28" textAnchor="middle" fontSize="10" fontWeight="bold" fill="#FF5722">$</text>
  </svg>
);

const InvoicesCardIcon = () => (
  <svg width="32" height="32" viewBox="0 0 48 48">
    <rect x="10" y="6" width="28" height="36" rx="2" fill="#2196F3" />
    <rect x="14" y="12" width="20" height="2" fill="white" />
    <rect x="14" y="18" width="16" height="2" fill="white" />
    <rect x="14" y="24" width="18" height="2" fill="white" />
    <rect x="14" y="30" width="12" height="2" fill="white" />
  </svg>
);

const CompensationCardIcon = () => (
  <svg width="32" height="32" viewBox="0 0 48 48">
    <circle cx="24" cy="20" r="12" fill="#FFC107" />
    <ellipse cx="24" cy="32" rx="8" ry="4" fill="#FFD54F" />
    <text x="24" y="24" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#795548">$</text>
  </svg>
);

const MastersCardIcon = () => (
  <svg width="32" height="32" viewBox="0 0 48 48">
    <rect x="8" y="8" width="32" height="32" rx="2" fill="#2196F3" />
    <rect x="12" y="14" width="12" height="8" fill="white" />
    <rect x="26" y="14" width="10" height="2" fill="white" />
    <rect x="26" y="18" width="8" height="2" fill="white" />
    <rect x="12" y="26" width="24" height="2" fill="white" />
    <rect x="12" y="32" width="20" height="2" fill="white" />
  </svg>
);

const navItems = [
  { id: 'dashboard', label: 'Dashboard', icon: DashboardIcon },
  { id: 'employees', label: 'Employees', icon: EmployeesIcon },
  { id: 'compensation', label: 'Compensation', icon: CompensationIcon },
  { id: 'timesheet', label: 'Timesheet', icon: TimesheetIcon },
  { id: 'leaves', label: 'Leaves', icon: LeavesIcon },
  { id: 'admin-leaves', label: 'Leave Management', icon: LeavesIcon },
  { id: 'payroll', label: 'Payroll', icon: PayrollIcon },
  { id: 'documents', label: 'Documents', icon: DocumentsIcon },
  { id: 'masters', label: 'Masters', icon: MastersIcon },
  { id: 'accounting', label: 'Accounting', icon: AccountingIcon },
  { id: 'ctc-calculator', label: 'HR CTC Module', icon: CompensationIcon },
  { id: 'settings', label: 'Settings', icon: SettingsIcon },
];

const dashboardCards = [
  { id: 'approvals', label: 'Approvals', icon: ApprovalsCardIcon },
  { id: 'leaves', label: 'Leaves', icon: LeavesCardIcon },
  { id: 'employees', label: 'Employees', icon: EmployeesCardIcon },
  { id: 'timesheet', label: 'Timesheet', icon: TimesheetCardIcon },
  { id: 'payroll', label: 'Payroll', icon: PayrollCardIcon },
  { id: 'invoices', label: 'Invoices', icon: InvoicesCardIcon },
  { id: 'compensation', label: 'Compensation', icon: CompensationCardIcon },
  { id: 'masters', label: 'Masters', icon: MastersCardIcon },
];

const HrmsHomeScreen = () => {
  const [activeNav, setActiveNav] = useState('dashboard');
  const [searchQuery, setSearchQuery] = useState('');
  const [employeesSubScreen, setEmployeesSubScreen] = useState('list'); // 'list' or 'create'

  const handleNavClick = (navId) => {
    setActiveNav(navId);
    // Reset sub-screens when navigating
    if (navId === 'employees') {
      setEmployeesSubScreen('list');
    }
  };

  const getPageTitle = () => {
    if (activeNav === 'employees' && employeesSubScreen === 'create') {
      return 'Create Employees';
    }
    const titles = {
      dashboard: 'Dashboard',
      employees: 'Employees',
      compensation: 'Compensation',
      timesheet: 'Timesheet',
      leaves: 'Leaves',
      'admin-leaves': 'Leave Management',
      payroll: 'Payroll',
      documents: 'Documents',
      masters: 'Masters',
      accounting: 'Accounting',
      'ctc-calculator': 'HR CTC Module',
      settings: 'Settings',
    };
    return titles[activeNav] || 'Dashboard';
  };

  return (
    <div className="home-container">
      {/* Sidebar */}
      <aside className="sidebar">
        <div className="logo-container">
          <img src={Logo} alt="TekTap HRMS" className="logo-image" />
        </div>

        <nav className="nav-menu">
          {navItems.map((item) => {
            const IconComponent = item.icon;
            return (
              <button
                key={item.id}
                className={`nav-item ${activeNav === item.id ? 'active' : ''}`}
                onClick={() => handleNavClick(item.id)}
              >
                <span className="nav-icon">
                  <IconComponent />
                </span>
                <span className="nav-label">{item.label}</span>
              </button>
            );
          })}
        </nav>
      </aside>

      {/* Main Content */}
      <main className="main-content">
        {/* Header */}
        <header className="header">
          <h2 className="page-title">{getPageTitle()}</h2>

          <div className="header-right">
            <div className="search-container">
              <SearchIcon />
              <input
                type="text"
                placeholder="Search here"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="search-input"
              />
            </div>

            <button className="notification-btn">
              <BellIcon />
            </button>

            <div className="user-profile">
              <div className="user-avatar">
                <img
                  src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face"
                  alt="User"
                />
              </div>
              <div className="user-info">
                <span className="user-name">Priya Verma</span>
                <span className="user-role">HR Manager</span>
              </div>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M6 9l6 6 6-6" />
              </svg>
            </div>
          </div>
        </header>

        {/* Content Area */}
        {activeNav === 'dashboard' && (
          <div className="dashboard-content">
            <div className="cards-container">
              <div className="cards-grid">
                {dashboardCards.map((card) => {
                  const IconComponent = card.icon;
                  return (
                    <button 
                      key={card.id} 
                      className="dashboard-card"
                      onClick={() => {
                        if (card.id === 'employees') handleNavClick('employees');
                        if (card.id === 'leaves') handleNavClick('leaves');
                        if (card.id === 'compensation') handleNavClick('compensation');
                      }}
                    >
                      <div className="card-icon">
                        <IconComponent />
                      </div>
                      <span className="card-label">{card.label}</span>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        {activeNav === 'employees' && employeesSubScreen === 'list' && (
          <EmployeesHome onAddEmployee={() => setEmployeesSubScreen('create')} />
        )}

        {activeNav === 'employees' && employeesSubScreen === 'create' && (
          <CreateEmployeeIndex onCancel={() => setEmployeesSubScreen('list')} />
        )}

        {activeNav === 'leaves' && (
          <EmployeeLeaveHome />
        )}

        {activeNav === 'compensation' && (
          <CompensationHome />
        )}

        {activeNav === 'accounting' && (
          <AccountingHome />
        )}

        {activeNav === 'admin-leaves' && (
          <AdminLeaveHome />
        )}

        {activeNav === 'ctc-calculator' && (
          <CTCCalculator />
        )}

        {activeNav === 'documents' && (
          <DocumentsHome />
        )}

        {/* Placeholder for other screens */}
        {!['dashboard', 'employees', 'leaves', 'compensation', 'accounting', 'admin-leaves', 'ctc-calculator', 'documents'].includes(activeNav) && (
          <div className="coming-soon">
            <h3>Coming Soon</h3>
            <p>This section is under development</p>
          </div>
        )}
      </main>
    </div>
  );
};

export default HrmsHomeScreen;

